import { render } from "./TabContainer.vue?vue&type=template&id=2d9016c2"
import script from "./TabContainer.vue?vue&type=script&lang=js"
export * from "./TabContainer.vue?vue&type=script&lang=js"
script.render = render

export default script